<template>
        <el-form :model="form" :rules="rules" ref="form" label-width="100px">
            <span style="margin-left: 25px; color: #000; font-size: 16px">{{examEditTextConfig.base.title }}</span>
            <el-row>
                <el-col :span="14">
                    <el-form-item :label="formTextConfig.examPlanName" prop="examPlanName" style="margin-top:30px">
                        <el-input v-model="form.examPlanName" :placeholder="formTextConfig.examPlanNameTip" :disabled="examStatus>=2"></el-input>
                    </el-form-item>
                    <el-form-item :label="formTextConfig.subject" prop="subjectId">
                        <el-select v-model="form.subjectId" filterable clearable :placeholder="formTextConfig.subjectTip" :disabled="examStatus>=2">
                            <el-option v-for="(item,index) in subjectOptions" :key="index" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="formTextConfig.examCategory" prop="examCategory">
                        <el-radio-group v-model="form.examCategory"  :disabled="examStatus>=2">
                            <el-radio :label="item.dict_value" v-for="item in examCategoryOptions" :key="item.dict_value">{{
                                item.dict_label
                                }}
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item :label="formTextConfig.examTime" prop="startTime">
                        <el-date-picker
                                class="datePicker"
                                v-model="form.startTime"
                                value-format="yyyy-MM-dd HH:mm"
                                type="datetime"
                                :placeholder="formTextConfig.startTime"
                                style="width:48%" @blur="computeExamDuration" :disabled="examStatus>=2">
                        </el-date-picker>
                        <div style="width:4%;display: inline-block;text-align: center">-</div>
                        <el-date-picker
                                class="datePicker"
                                v-model="form.endTime"
                                value-format="yyyy-MM-dd HH:mm"
                                type="datetime"
                                :placeholder="formTextConfig.endTime"
                                style="width:48%" @blur="computeExamDuration" :disabled="examStatus==3">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item :label="formTextConfig.examDuration"  prop="examDuration">
                        <el-row>
                            <el-col :span="12">
                                <el-autocomplete v-model="form.examDuration" :fetch-suggestions="querySearch"
                                                 :placeholder="formTextConfig.examDurationRule"
                                                 style="width:calc(100% - 10px)" clearable :disabled="examStatus==3"></el-autocomplete>
                            </el-col>
                            <el-col :span="12">
                                <el-select v-model="form.examDurationUnit" :disabled="examStatus==3">
                                    <el-option v-for="item in unitOptions" :key="item.dict_value" :label="item.dict_label"
                                               :value="item.dict_value"></el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item :label="formTextConfig.gradingRule" prop="gradingRule">
                        <el-radio-group v-model="form.gradingRule" :disabled="examStatus==3">
                            <el-radio :label="item.key" v-for="item in gradingRules" :key="item.key" style="width:100%;line-height:40px;">{{
                                item.label
                                }}
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="">
                        <el-button type="primary" @click="submitExam" v-if="examStatus != 3" :loading="loading">{{ formTextConfig.button.ok }}</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
</template>
<script>
import {getDict} from "@/api/dict"
import {addExam, updateExam, getExam} from "@/api/arrangement";
import {parseTime} from "@/utils/common";
export default {
    data() {
        return {
            loading: false,
            form: {
                examPlanName: null,
                subjectId: null,
                examCategory: 'normal',
                startTime: null,
                endTime: null,
                examDuration: null,
                examDurationUnit: null,
                gradingRule: null
            },
            old: {
                examPlanName: null,
                subjectId: null,
                examCategory: 'normal',
                startTime: null,
                endTime: null,
                examDuration: null,
                examDurationUnit: null,
                gradingRule: null
            },
            examId: this.$route.query.id,
            rules: {
                examPlanName: [
                    {required: true, message: "竞赛计划不能为空", trigger: "blur"},
                    { max: 50, message: '竞赛计划字符不超过50', trigger: 'blur'}
                ],
                subjectId: [
                    {required: true, message: "赛项名称不能为空", trigger: "blur"}
                ],
                examCategory: [
                    {required: true, message: "竞赛类型不能为空", trigger: "blur"}
                ],
                startTime: [
                    {required: true, message: "竞赛时间不能为空", trigger: "blur"},
                    {
                        validator: (rule, value, callback) => {
                            let now = parseTime(new Date())
                            if (this.examStatus <2 && this.form.startTime < now) {
                                callback(new Error('开始时间小于当前时间'))
                            } else if (now > this.form.endTime) {
                                callback(new Error('结束时间小于当前时间'))
                            } else {
                                callback()
                            }
                        }, trigger: 'blur'
                    }
                ],
                examDuration: [
                    {required: true, message: "竞赛时长不能为空", trigger: "blur"},
                    {
                        validator: (rule, value, callback) => {
                            let startTime = new Date(this.form.startTime);
                            let endTime = new Date(this.form.endTime);
                            let diffMinutes = Math.abs((endTime - startTime) / (1000 * 60));
                            let examDuration = parseInt(this.form.examDuration)
                            this.form.examDuration = parseInt(this.form.examDuration)
                            if (this.form.examDurationUnit === 'hour') {
                                examDuration = examDuration * 60
                            } else if (this.form.examDurationUnit === 'day') {
                                examDuration = examDuration * 60 * 24
                            }
                            if (examDuration > diffMinutes) {
                                callback(new Error('时长超过时间'))
                            }
                            if (value && /^[1-9]*[1-9][0-9]*$/.test(value) === false) {
                                callback(new Error('仅支持输入正整数'))
                            } else {
                                callback()
                            }
                        }, trigger: 'blur'
                    }
                ],
                gradingRule: [
                    {required: true, message: "评分规则不能为空", trigger: "blur"}
                ]
            },
            examCategoryOptions: [],
            subjectOptions: [],
            unitOptions:[],
            gradingRules:[],
            results: {
                minute: [{value: '120'}, {value: '150'}, {value: '180'}, {value: '240'}],
                hour: [{value: '6'}, {value: '8'}, {value: '12'}, {value: '24'}],
                day: [{value: '1'}, {value: '2'}, {value: '3'}]
            },
            examStatus: 0
        }
    },
    props: [],
    computed: {
        examEditTextConfig() {
            return this.$store.state.global.textConfig.backend.arrangement.examEdit
        },
        formTextConfig() {
            return this.examEditTextConfig.base.form
        },

    },
    created() {
        getDict('exam_category').then(res => {
            this.examCategoryOptions = res.data
        })
        this.$store.dispatch("getSubjectList", {page_number: 1, page_size: 1000}).then(res => {
            if (res.status==200) {
                this.subjectOptions = res.data.list
            }
        })
        this.$store.dispatch("getDict", 'exam_duration_unit').then(res => {
            this.unitOptions = res.data
            if (this.unitOptions.length && !this.form.examDurationUnit) {
                this.form.examDurationUnit = this.unitOptions[0].dict_value
            }
        });
        this.$store.dispatch('getArrangementGradingRule').then(res => {
            this.gradingRules = res.data
            if (this.gradingRules.length && !this.form.gradingRule) {
                this.form.gradingRule = this.gradingRules[0].key
            }
        });
        if (this.$route.query.id || this.$store.state.arrangeExam.examId) {
            let id = this.$route.query.id ? this.$route.query.id : this.$store.state.arrangeExam.examId
            this.$store.state.arrangeExam.examId = null
            getExam(id).then(res => {
                if (res.status === 200) {
                    this.form.examPlanName = res.data.examPlan.name
                    this.form.subjectId = res.data.subjectId
                    this.form.examCategory = res.data.examCategory
                    this.form.startTime = res.data.startTime
                    this.form.endTime = res.data.endTime
                    this.form.examDuration = res.data.examDuration
                    this.form.examDurationUnit = res.data.examDurationUnit
                    this.form.gradingRule = res.data.gradingRule
                    this.examStatus = res.data.examStatus
                    this.old.examPlanName = res.data.examPlan.name
                    this.old.subjectId = res.data.subjectId
                    this.old.examCategory = res.data.examCategory
                    this.old.startTime = res.data.startTime
                    this.old.endTime = res.data.endTime
                    this.old.examDuration = res.data.examDuration
                    this.old.examDurationUnit = res.data.examDurationUnit
                    this.old.gradingRule = res.data.gradingRule
                }
            })
        }
    },
    methods: {
        submitExam() {
            this.$refs.form.validate(vaild => {
                if (vaild) {
                    this.loading = true;
                    let subject = this.subjectOptions.filter((item) => item.id == this.form.subjectId)
                    if(subject && subject.length > 0) {
                        this.form.subject = subject[0].name
                    }
                    if (this.examId) {
                        updateExam(this.examId, this.form).then(res => {
                            if (res.status === 200) {
                                this.$message.success("编辑成功")
                                this.$emit('setExamIdAndCategory', this.examId, this.form.examCategory)
                                this.old = JSON.parse(JSON.stringify(this.form))
                            }
                            this.loading = false;
                        })
                    } else {
                        addExam(this.form).then(res => {
                            if (res.status === 200) {
                                this.$message.success("创建成功")
                                this.$emit('setExamIdAndCategory', res.data, this.form.examCategory)
                                this.examId = res.data
                                this.old = JSON.parse(JSON.stringify(this.form))
                            }
                            this.loading = false;
                        })
                    }
                }
            })
        },
        reset() {
            this.form = {
                examPlanName: null,
                subjectId: null,
                examCategory: null,
                startTime: null,
                endTime: null,
                examDuration: null,
                examDurationUnit: null,
                gradingRule: null
            }
            this.$refs.form.resetFields()
        },
        querySearch(queryString, cb) {
            cb(this.results[this.form.examDurationUnit])
        },
        computeExamDuration() {
            if (this.form.startTime && this.form.endTime) {
                let diff = new Date(this.form.endTime).getTime() - new Date(this.form.startTime).getTime();
                if (diff > 0) {
                    let day = 86400000;
                    let hour = 3600000;
                    let min = 60000;
                    if (diff % day == 0) {
                        this.form.examDuration = diff/day
                        this.form.examDurationUnit = 'day'
                    } else if (diff % hour == 0) {
                        this.form.examDuration = diff/hour
                        this.form.examDurationUnit = 'hour'
                    } else {
                        this.form.examDuration = diff/min
                        this.form.examDurationUnit = 'minute'
                    }
                }
            }
        },
        checkChange() {
            let flag = true;
            for (const key in this.old) {
                if (this.form.hasOwnProperty(key)) {
                    if (this.form[key] !== this.old[key]) {
                        flag = false;
                        break;
                    }
                }  else {
                    flag = false;
                    break;
                }
            }
            return flag;
        }

    }
}
</script>

<style scoped>

</style>